<script setup>
import SubTabs from "../../../assets/components/SubTabs.vue";
import InvoicesList from "./ListInvoices.vue";
import {__, _mareike_nonce} from "../../../assets/javascripts/library";


const props = defineProps({
  data: {
    type: [Array, Object],
    default: () => []
  },
  load_invoice_id: {
    type: Number,
    default: 0
  },

  cost_unit_id: Number,
})

const subTabList = [
  {
    name: 'list-new',
    title: __('New invoices', 'mareike'),
    component: InvoicesList,
    endpoint: "/wp-json/mareike/invoices/list-new?invoice_id=" + props.load_invoice_id + "&cost_unit_id=" + props.cost_unit_id + "&mareike_nonce="+_mareike_nonce(),
    deep_jump_id: props.load_invoice_id,
  },
  {
    name: 'list-approved',
    title: __('Unexported invoices', 'mareike'),
    component: InvoicesList,
    endpoint: "/wp-json/mareike/invoices/list-approved?invoice_id=" + props.load_invoice_id + "&cost_unit_id=" + props.cost_unit_id + "&mareike_nonce="+_mareike_nonce(),
    deep_jump_id: props.load_invoice_id,
  },

  {
    name: 'list-exported',
    title: __('Exported invoices', 'mareike'),
    component: InvoicesList,
    endpoint: "/wp-json/mareike/invoices/list-exported?invoice_id=" + props.load_invoice_id + "&cost_unit_id=" + props.cost_unit_id + "&mareike_nonce="+_mareike_nonce(),
    deep_jump_id: props.load_invoice_id,
  },

  {
    name: 'list-denied',
    title: __('Denied invoices', 'mareike'),
    component: InvoicesList,
    endpoint: "/wp-json/mareike/invoices/list-denied?invoice_id=" + props.load_invoice_id + "&cost_unit_id=" + props.cost_unit_id + "&mareike_nonce="+_mareike_nonce(),
    deep_jump_id: props.load_invoice_id,
  }
]
</script>

<template>
  <SubTabs :tabs="subTabList" :preSelected="data.target" />
</template>

